import Cookies from 'js-cookie';

const STORAGE_KEY = {
  campaignId: 'campaignid',
  campaignSource: 'campaignsource',
  referrer: 'referrer',
};

export function initCampaignTracking() {
  const consent = Cookies.get('analytics') !== 'false';
  if (!consent) return;

  const urlParams = new URLSearchParams(window.location.search);

  const campaignId = urlParams.get('campaignid');
  const campaignSource = urlParams.get('campaignsource');
  const referrer = document.referrer || null;

  if (campaignId) {
    localStorage.setItem(STORAGE_KEY.campaignId, campaignId);
  }
  if (campaignSource) {
    localStorage.setItem(STORAGE_KEY.campaignSource, campaignSource);
  }
  if (referrer) {
    localStorage.setItem(STORAGE_KEY.referrer, referrer);
  }
}

export function getCampaignData() {
  return {
    campaignid: localStorage.getItem(STORAGE_KEY.campaignId) ?? '',
    campaignsource: localStorage.getItem(STORAGE_KEY.campaignSource) ?? '',
    referrer: localStorage.getItem(STORAGE_KEY.referrer) ?? '',
  };
}
